import { render } from "./editUserInfo.vue?vue&type=template&id=20aa457e&scoped=true"
import script from "./editUserInfo.vue?vue&type=script&lang=js"
export * from "./editUserInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aa457e"]])

export default __exports__